import moment from "moment";
import {
  SET_PAGE,
  SET_SEARCH,
  SET_ORDER_BY,
  SET_SORT_BY,
  GET_REVIEWS,
} from "../../shared/constants/ActionTypes";

const initialRating = {
  reviewData: [],
  reviewCount: 0,
  page: 1,
  search: "",
  sortby: "",
  orderby: "desc",
};

function reviewReducer(state = initialRating, action) {
  switch (action.type) {
    case GET_REVIEWS:
      return {
        ...state,
        reviewData: action.payload.reviewData?.map((review) => {
          return {
            ...review,
            updatedAtFormatted: moment(review.createdAt).format("ll"),
          };
        }),
        reviewCount: action.payload.totalCount,
        // professionalProfileCount: action.payload.totalCount,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };
    default:
      return state;
  }
}

export default reviewReducer;
